/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_References_Max_Files_WarningInputs */



/**
* | output |
* | --- |
* | "File limit ({count}) reached" |
*
* @param {Project_References_Max_Files_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_max_files_warning = /** @type {((inputs: Project_References_Max_Files_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Max_Files_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dateibegrenzung (${i?.count}) erreicht`)
	return /** @type {LocalizedString} */ (`File limit (${i?.count}) reached`)
});